const size = {
  mobile: '770px',
  tablet: '1024px',
  desktop: '3000px',
};

const theme = {
  primaryColor: '#0058a3',

  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  desktop: `(max-width: ${size.desktop})`,
};

export default theme;
